import React from 'react';

function Copy16Icon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.62404 2.34613C5.55689 2.43845 5.5 2.59067 5.5 2.78125V4.05C5.5 4.32614 5.27614 4.55 5 4.55C4.72386 4.55 4.5 4.32614 4.5 4.05V2.78125C4.5 2.40228 4.611 2.03888 4.8153 1.75796C5.01924 1.47753 5.34351 1.25 5.75 1.25H12.25C12.6565 1.25 12.9808 1.47753 13.1847 1.75796C13.389 2.03888 13.5 2.40228 13.5 2.78125V11.7188C13.5 12.0977 13.389 12.4611 13.1847 12.742C12.9808 13.0225 12.6565 13.25 12.25 13.25H11.2222C10.9461 13.25 10.7222 13.0261 10.7222 12.75C10.7222 12.4739 10.9461 12.25 11.2222 12.25H12.25C12.2577 12.25 12.3085 12.2467 12.376 12.1539C12.4431 12.0616 12.5 11.9093 12.5 11.7188V2.78125C12.5 2.59067 12.4431 2.43845 12.376 2.34613C12.3085 2.25332 12.2577 2.25 12.25 2.25H5.75C5.74227 2.25 5.69153 2.25332 5.62404 2.34613Z"
        fill="#121212"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.6101 4.83693C3.55012 4.91191 3.5 5.03419 3.5 5.1875V13.3125C3.5 13.4658 3.55012 13.5881 3.6101 13.6631C3.66935 13.7371 3.72199 13.75 3.75 13.75H10.25C10.278 13.75 10.3307 13.7371 10.3899 13.6631C10.4499 13.5881 10.5 13.4658 10.5 13.3125V5.1875C10.5 5.03419 10.4499 4.91191 10.3899 4.83693C10.3307 4.76288 10.278 4.75 10.25 4.75H3.75C3.72199 4.75 3.66935 4.76288 3.6101 4.83693ZM2.5 5.1875C2.5 4.50347 2.96129 3.75 3.75 3.75H10.25C11.0387 3.75 11.5 4.50347 11.5 5.1875V13.3125C11.5 13.9965 11.0387 14.75 10.25 14.75H3.75C2.96129 14.75 2.5 13.9965 2.5 13.3125V5.1875Z"
        fill="#121212"
      />
    </svg>
  );
}

export default Copy16Icon;
